module.exports = __webpack_public_path__ + "ipetbooking/admin/img/fbUrl.03bae35a.jpg";